import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import React from 'react';

type DefaultProps = Pick<ButtonProps, 'variant' | 'color' | 'size'>;

type MbButtonType = 'primary' | 'secondary' | 'danger' | 'inherit';

export type MbButtonProps = { btnType?: MbButtonType; isEllipse?: boolean; hasBlackBorder?: boolean } & ButtonProps;

export const MbButton = React.forwardRef<HTMLButtonElement, MbButtonProps>((props, ref) => {
  const defaultProps: DefaultProps = {
    variant: 'outlined',
    size: 'medium',
  };

  const { btnType, isEllipse, sx, hasBlackBorder, ...others } = props;
  switch (btnType) {
    case 'primary':
      defaultProps.variant = 'contained';
      break;
    case 'secondary':
      defaultProps.variant = 'outlined';
      break;
    case 'danger':
      defaultProps.variant = 'contained';
      defaultProps.color = 'error';
      break;
    case 'inherit':
      defaultProps.variant = 'contained';
      defaultProps.color = 'inherit';
      break;
    default:
      break;
  }

  let newSx = isEllipse ? { borderRadius: '1.5rem', ...sx } : sx;

  newSx = hasBlackBorder ? { ...newSx, border: '2px solid black' } : newSx;

  const newProps: ButtonProps = { ...defaultProps, ...others, sx: newSx };

  return <Button {...newProps} ref={ref} />;
});
